import SystemDataService from '../Services/SystemDataService';

// --- 1. THE CACHE STORAGE ---
let ALL_PROJECTS_CACHE = null;
const PROJECT_SLUG_CACHE = {};

// --- 2. LOCAL DATA FALLBACK ---
const projectsFormatter = [
    {
        "id": "prj-one",
        "status": true,
        "slug": "project-one",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
        "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg"
        ],
        "palette": [
            { "color": "#1d2326", "name": "Dark Slate" },
            { "color": "#f5f6f5", "name": "Off White" },
            { "color": "#e67e22", "name": "Roof Clay" }
        ],
        "stats": [
            { "label": "Stat One", "value": "3" },
            { "label": "Stat Two", "value": "95" },
            { "label": "Stat Three", "value": "150" },
            { "label": "Stat Four", "value": "5" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    },
    {
        "id": "prj-four",
        "status": true,
        "slug": "project-two",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
         "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg"
        ],
        "palette": [
            { "color": "#0E5596", "name": "Service Blue" },
            { "color": "#FAD20A", "name": "Safety Yellow" },
            { "color": "#E9F0F8", "name": "Steel White" }
        ],
        "stats": [
            { "label": "Stat One", "value": "45" },
            { "label": "Stat Two", "value": "90" },
            { "label": "Stat Three", "value": "1" },
            { "label": "Stat Four", "value": "18" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    },
    {
        "id": "prj-two",
        "status": true,
        "slug": "project-three",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
        "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg"
        ],
        "palette": [
            { "color": "#083B63", "name": "Royal Blue" },
            { "color": "#AF9153", "name": "Gold foil" },
            { "color": "#E1A511", "name": "Giraffe Orange" },
            { "color": "#FFFFFF", "name": "Paper White" }
        ],
        "stats": [
            { "label": "Stat One", "value": "200" },
            { "label": "Stat Two", "value": "40" },
            { "label": "Stat Three", "value": "12000" },
            { "label": "Stat Four", "value": "50" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    },
    {
        "id": "prj-three",
        "status": true,
        "slug": "project-four",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
       "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg"
        ],
        "palette": [
            { "color": "#006994", "name": "Sea Blue" },
            { "color": "#ffffff", "name": "white" },
            { "color": "#0C8A8C", "name": "Marine Blue" },
            { "color": "#000000", "name": "black" }

        ],
        "stats": [
            { "label": "Stat One", "value": "40" },
            { "label": "Stat Two", "value": "200" },
            { "label": "Stat Three", "value": "95" },
            { "label": "Stat Four", "value": "50000" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    },
    {
        "id": "prj-five",
        "status": true,
        "slug": "project-five",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
        "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg"
        ],
        "palette": [
            { "color": "#FA2D55", "name": "Power Red" },
            { "color": "#2864EB", "name": "Electric Blue" },
            { "color": "#000000", "name": "Black" },
            { "color": "#FFFFFF", "name": "White" }
        ],
        "stats": [
            { "label": "Stat One", "value": "300" },
            { "label": "Stat Two", "value": "1" },
            { "label": "Stat Three", "value": "120" },
            { "label": "Stat Four", "value": "100" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    },
    {
        "id": "prj-six",
        "status": true,
        "slug": "project-six",
        "clientName": "Your Business",
        "location": "City Name, Region",
        "website": "https://www.example.com",
        "mainImage": "/placeholder.svg",
        "logo": "/placeholder.svg",
        "title": "Headline goes here",
        "subtitle": "Add your subtitle here. This placeholder describes the project.",
        "challenge": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "solution": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "result": "Add your content here. This placeholder describes the section and can be replaced with your own copy.",
        "tags": ["Tag One", "Tag Two", "Tag Three", "Tag Four"],
        "video": "/placeholder.svg",
        "gallery": [
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
            "/placeholder.svg",
        ],
        "palette": [
            { "color": "#B19064", "name": "Premium Gold" },
            { "color": "#644A30", "name": "Earth Brown" },
            { "color": "#FFFFFF", "name": "Clean White" }
        ],
        "stats": [
            { "label": "Stat One", "value": "35" },
            { "label": "Stat Two", "value": "22" },
            { "label": "Stat Three", "value": "10" },
            { "label": "Stat Four", "value": "300" }
        ],
        "sections": [
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            },
            {
                "title": "Section Title",
                "content": "Add your content here. This placeholder describes the section and can be replaced with your own copy."
            }
        ],
        "faqList": [
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            },
            {
                "question": "Frequently asked question?",
                "answer": "Answer goes here."
            }
        ]
    }
];

export default projectsFormatter;

// --- 3. FETCHING FUNCTIONS ---
// (No changes to the fetching logic below)

export const getProjectsData = async () => {
    if (ALL_PROJECTS_CACHE) {
        return ALL_PROJECTS_CACHE;
    }

    try {
        const apiData =await SystemDataService.getProjectsData();

        if (Array.isArray(apiData) && apiData.length > 0) {
            ALL_PROJECTS_CACHE = apiData;
            return apiData;
        } else {
            console.warn('Projects API returned empty, falling back to local data.');
            ALL_PROJECTS_CACHE = projectsFormatter;
            return projectsFormatter;
        }
    } catch (err) {
        console.error('Failed to load projects data from API, using local fallback', err);
        return projectsFormatter;
    }
};

export const getProjectBySlug = async (slug) => {
    if (PROJECT_SLUG_CACHE[slug]) {
        return PROJECT_SLUG_CACHE[slug];
    }

    if (ALL_PROJECTS_CACHE) {
        const found = ALL_PROJECTS_CACHE.find(prj => prj.slug === slug);
        if (found) {
            PROJECT_SLUG_CACHE[slug] = found;
            return found;
        }
    }

    try {
        const apiData = undefined; 
        
        let result = null;
        if (Array.isArray(apiData) && apiData.length > 0) {
            result = apiData[0];
        } else if (apiData && typeof apiData === 'object') {
            result = apiData;
        }

        if (result) {
            PROJECT_SLUG_CACHE[slug] = result;
            return result;
        }

        console.warn(`Project API empty for slug: ${slug}, falling back to local.`);
        const localResult = projectsFormatter.find(prj => prj.slug === slug);
        if (localResult) PROJECT_SLUG_CACHE[slug] = localResult;
        return localResult;

    } catch (err) {
        console.error('Failed to load project from API, using local fallback', err);
        return projectsFormatter.find(prj => prj.slug === slug);
    }
};

export const getAllProjects = () => projectsFormatter;

export const clearProjectsCache = () => {
  ALL_PROJECTS_CACHE = null;
};